import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/contaminantes/contaminantes';
import ContaminantesList from './Contaminantes';


const ms2p = (state) => {
  return {
    ...state.contaminantes,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ContaminantesList);
